import PropTypes from 'prop-types';
export const footerPropTypes = {
  /**
   * Newsletter object
   */
  newsletter: PropTypes.shape({
    heading: PropTypes.string,
    description: PropTypes.string,
    placeholder: PropTypes.string,
    consent: PropTypes.string
  }),
  /**
   * Contact object
   */
  contact: PropTypes.shape({
    heading: PropTypes.string,
    email: PropTypes.string,
    number: PropTypes.string,
    hours: PropTypes.string
  }),
  /**
   * Single column contains - heading and items as an array of name and href
   */
  columns: PropTypes.arrayOf(PropTypes.shape({
    heading: PropTypes.string,
    links: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string,
      href: PropTypes.string
    }))
  })),
  /**
   * Social Media elements
   */
  socials: PropTypes.shape({
    heading: PropTypes.string,
    items: PropTypes.arrayOf(PropTypes.shape({
      icon: PropTypes.string,
      url: PropTypes.string,
      title: PropTypes.string
    }))
  }),
  /**
   * Address
   */
  address: PropTypes.string,
  /**
   * Copyright content
   */
  copyright: PropTypes.string,
  /**
   * Interlinks as string of raw html structure
   */
  brands: PropTypes.string,
  /**
   * Booleans about subscription status
   */
  subscriptionStatus: PropTypes.shape({
    isSending: PropTypes.bool,
    isSubscribed: PropTypes.bool,
    isEmailTaken: PropTypes.bool
  }),
  /**
   * Disclaimer content as object of label and text
   */
  disclaimer: PropTypes.shape({
    heading: PropTypes.string,
    text: PropTypes.string
  }),
  /**
   * Gatsby API function
   */
  onSubscribe: PropTypes.func,
  /**
   * If true, width of the footer is the same as the container grid
   */
  hasFixedWidth: PropTypes.bool
};